export const getLocalStorage = (key: string): Object => {
  const val = localStorage.getItem(key);
  return val ? JSON.parse(val) : {};
};
